// @ts-nocheck

import React from "react";
import { QuestionsController } from "../../classes/QuestionsController"
import { defPath } from "../../config/defPath";
import gsap from 'gsap'


export default function Questions() {

	const closeQuestions = () => {
		let container = document.querySelector(".ar__questions_overlay");
		let question = document.querySelector(".ar__questions");
		const timeline = gsap.timeline({
			defaults: {
				ease: 'power1.in',
				duration: 0.35
			}
		})
		
		timeline.to(question, {
			y: '20%',
			opacity: 0
		}, 0)
		timeline.to(container, {
			opacity: 0,
			onComplete() {
				this.targets()[0].style.display = 'none'
			}
		}, 0)
		
	}

	const handleClose = () => {
		window.soundController && window.soundController.play('cerrar', false, 1)
		closeQuestions()
		window.avatar.toggleControls(true)
		window.npc.restore()
		window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Card',
      'event_label': 'Close question - PassionPoint',
      'interaction':'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': 'Cerrar',
    });
	}

	return (
		<React.StrictMode>
			<section className="ar__questions_overlay">
				<div className="ar__questions_overlay__content">
					<button className="ar__questions--close black_24" onTouchEnd={handleClose} onClick={handleClose}>
						<span>Cerrar</span>
						<img src={`${defPath}/assets/images/icons/icon-close.svg`} alt="icono close" />
					</button>

					<div className="ar__questions">
						<div className="ar__questions--content">
							{/* dynamic questionsController.ts */}
						</div>
					</div>
				</div>

			</section>

		</React.StrictMode>
	)
};
